
export const setAdsModalDisplay = (adsModalDisplay) => (
  {
    type:'SET_ADS_MODAL_DISPLAY',
    adsModalDisplay,
  }
);

export const setCurrentAdsListing = (currentAdsListing) => (
  {
    type:'SET_CURRENT_ADS_LISTING',
    currentAdsListing,
  }
);
